import ApiAcces from "@/shared/services/ApiAcces";
import type IntegrationAccess from "../models/IntegrationAccess";

export interface GrantAccessRequest {
  IntegrationProviderId: string;
  GrantedToUserId: string;
}

export default class IntegrationAccessService extends ApiAcces {
  async getAll(): Promise<IntegrationAccess[]> {
    return (await this.api.get("api/integrations/access")).data;
  }

  async getByUser(userId: string): Promise<IntegrationAccess[]> {
    return (await this.api.get(`api/integrations/access/user/${userId}`)).data;
  }

  async grant(request: GrantAccessRequest): Promise<IntegrationAccess> {
    return (await this.api.post("api/integrations/access", request)).data;
  }

  async revoke(id: string): Promise<void> {
    await this.api.delete(`api/integrations/access/${id}`);
  }

  async update(id: string, enabled: boolean): Promise<void> {
    // The endpoint binds [FromBody] bool: the payload must be a bare `true`/`false`,
    // not an { enabled } wrapper.
    await this.api.patch(`api/integrations/access/${id}`, JSON.stringify(enabled), {
      headers: { "Content-Type": "application/json" },
    });
  }
}
